import { Alert, Text } from '@nimbus-ds/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

interface StockAlertProps {
  isVisible: boolean;
  onClose: () => void;
}

function StockAlert({ isVisible, onClose }: Readonly<StockAlertProps>) {
  const t = useTranslationCatalog();

  if (!isVisible) {
    return null;
  }

  return (
    <Alert
      appearance="danger"
      title={t('transfers.new.stockAlert.title')}
      onRemove={onClose}
    >
      <Text>{t('transfers.new.stockAlert.description')}</Text>
    </Alert>
  );
}

export default StockAlert;
